var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'photo-show', params: { id: _vm.photo.id } }}},[_c('img',{staticClass:"photo-container",attrs:{"src":_vm.photo.urls.small}})])}
var staticRenderFns = []

export { render, staticRenderFns }